import { useInfiniteFetch } from "../hooks";

export const useGetJobbersSearch = (params) =>
  useInfiniteFetch(`/jobbers`, params, {
    queryKey: ["/jobbers", params],
  });
